// User Interface 
export interface IUser {
    firstName: string;
    lastName: string;
    partner?: string;
    initials?: string;
    role?: number;
    email?: string;
    fleet?: [string];
    createdAt?: Date;
    updatedAt?: Date;
}

// for GraphQL queries 
export const USER_FIELDS = `
    fragment USER_FIELDS on User {
        firstName
        lastName
        partner
        role
        fleet
        updatedAt
        email
        createdAt
    }`;
    

